// extracted by mini-css-extract-plugin
export var downArrow = "_9t-0";
export var infoTooltipIcon = "_9t-3";
export var label = "_9t-1";
export var optionCard = "_9t-4";
export var upArrow = "_9t-2";